import { c as _c } from "react/compiler-runtime";
import type { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
export const BoxAbsolute = t0 => {
  const $ = _c(6);
  const {
    children,
    sx,
    ref
  } = t0;
  let t1;
  if ($[0] !== sx) {
    t1 = {
      position: "absolute",
      ...sx
    };
    $[0] = sx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== ref || $[4] !== t1) {
    t2 = <Box ref={ref} sx={t1}>{children}</Box>;
    $[2] = children;
    $[3] = ref;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};